import {
    DOCTOR_SPECIALIZATION_SUCCESS,
    DOCTOR_SPECIALIZATION_PENDING,
    DOCTOR_SPECIALIZATION_FAIL,
    ADD_DOCTOR_SPECIALIZATION_SUCCESS,
    ADD_DOCTOR_SPECIALIZATION_PENDING,
    ADD_DOCTOR_SPECIALIZATION_FAIL,
    UPDATE_DOCTOR_SPECIALIZATION_SUCCESS,
    UPDATE_DOCTOR_SPECIALIZATION_PENDING,
    UPDATE_DOCTOR_SPECIALIZATION_FAIL,
    SET_MESSAGE,
    DOWNLOAD_DOCTOR_SPECIALIZATION_SUCCESS, 
    DOWNLOAD_DOCTOR_SPECIALIZATION_PENDING,
    DOWNLOAD_DOCTOR_SPECIALIZATION_FAIL,
} from "../types";
import { toast} from 'react-toastify'; 
import UserService from "../../services/user.service";

//All doctor specializations

export const getDoctorSpecializations = (pageNumber, pageSize, searchQuery) => async(dispatch) => {
    dispatch({
        type: DOCTOR_SPECIALIZATION_PENDING,
        payload: { specializations: "isLoading" },
    });
    return await UserService.getDoctorSpecialization(pageNumber, pageSize, searchQuery).then(
        (data) => {
            data.data.status ?
                dispatch({
                    type: DOCTOR_SPECIALIZATION_SUCCESS,
                    payload: { specializations: data.data},
                }) :
                dispatch({
                    type: DOCTOR_SPECIALIZATION_FAIL,
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: DOCTOR_SPECIALIZATION_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    });
};

    //add doctor specialization
export const addDoctorSpecializations = (body) => async(dispatch) => {
    dispatch({
        type: ADD_DOCTOR_SPECIALIZATION_PENDING,
        payload: { addSpecializations: "isLoading" },
    });
    return await UserService.addDoctorSpecialization(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: ADD_DOCTOR_SPECIALIZATION_SUCCESS,
                    payload: { addSpecializations : data.data.status },
                }) :
                dispatch({
                    type: ADD_DOCTOR_SPECIALIZATION_FAIL,
                    payload: { addSpecializations : data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: ADD_DOCTOR_SPECIALIZATION_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    }).finally(()=>{
        dispatch({
          type: ADD_DOCTOR_SPECIALIZATION_FAIL,
        });
      });
};

//update doctor speciaizations
export const updateDoctorSpecializations = (body) => async(dispatch) => {
    dispatch({
        type: UPDATE_DOCTOR_SPECIALIZATION_PENDING,
        payload: { updateSpecializations: "isLoading" },
    });
    return await UserService.updateDoctorSpecialization(body).then(
        (data) => {
            data.data.status ? toast.success("Specialization updated Successfully !", {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: UPDATE_DOCTOR_SPECIALIZATION_SUCCESS,
                    payload: { updateSpecializations : data.data.status },
                }) :
                dispatch({
                    type: UPDATE_DOCTOR_SPECIALIZATION_FAIL,
                    payload: { updateSpecializations : data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: UPDATE_DOCTOR_SPECIALIZATION_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    }).finally(()=>{
        dispatch({
          type: UPDATE_DOCTOR_SPECIALIZATION_FAIL,
        });
      });
}

// Download doctor specialization
export const downloadDoctorSpecialization = () => async (dispatch) => {
  dispatch({
    type: DOWNLOAD_DOCTOR_SPECIALIZATION_PENDING,
    payload: { downloadDoctorSpecialization: "isLoading" },
  });

  try {
    const response = await UserService.downloadDoctorSpecialization({
      responseType: "blob",
    });
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
      : "DoctorSpecialization.csv";

    const blob = new Blob([response.data], {
      type: "text/csv",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    toast.success("Doctor Specialization file downloaded successfully!", {
      autoClose: 2000,
    });

    dispatch({
      type: DOWNLOAD_DOCTOR_SPECIALIZATION_SUCCESS,
      payload: { downloadDoctorSpecialization: true },
    });
  } catch (error) {
    console.error("Error downloading Doctor Specialization file:", error);
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();

    toast.error("Failed to download the Doctor Specialization file.", {
      autoClose: 2000,
    });

    dispatch({
      type: DOWNLOAD_DOCTOR_SPECIALIZATION_FAIL,
      payload: { downloadDoctorSpecialization: false },
    });
  }
};